import * as z from 'zod';
import { StoreRegion } from '~/graphql/graphql.gen';
import { SaleType } from '~/stores/sale';

export const salesQueryParamsSchema = z.object({
  q: z.string().optional(),
  region: z.enum([StoreRegion.Fr, StoreRegion.Us]).catch(StoreRegion.Fr),
  type: z
    .enum([SaleType.Ongoing, SaleType.Next, SaleType.Ended, SaleType.Cancelled])
    .catch(SaleType.Ongoing),
});

export type SalesQueryParams = z.infer<typeof salesQueryParamsSchema>;
